import FlowerPattern from "./flower-pattern.svg";
import Basic4Avatar from "./basic-4-avatar.jpg";
import Slide1 from "./preview/slide-1.png";
import Slide2 from "./preview/slide-2.png";
import Slide3 from "./preview/slide-3.png";
import Slide4 from "./preview/slide-4.png";
import BgOption1 from "./../images/bg-option-1.png";
import BgOption2 from "./../images/bg-option-2.png";
import BgOption3 from "./../images/bg-option-3.png";
import { MultilineView, TextView } from "../../components";
import BaseTemplate from "../base";

class Basic4 extends BaseTemplate {
  constructor() {
    super();
    this.name = "Basic #4";
    this.id = "5";
    this.url = "/ai/carousels/basic-5";
    this.description =
      "Create a simple and sleek carousel without the need for your image";
    this.common_settings = {
      elements: [
        {
          label: "Your Name",
          type: "text",
          value: "Orlando Diggs",
        },
        {
          label: "Profile Pic",
          type: "logo",
          key: "logo",
          value: {
            type: "image",
            image: Basic4Avatar,
          },
        },
        {
          label: "Handle",
          type: "text",
          value: "@ordiggs",
        },
        {
          label: "Background",
          type: "background",
          key: "background_color",
          value: {
            type: "color",
            image: "",
            color: "#fffaec",
            color_options: [
              "#2cd4bf",
              "#38bcf7",
              "#feb022",
              "#f87066",
              "#33d583",
              "#818cf8",
              "#f471b6",
              "#bf84fc",
            ],
            image_options: [
              {
                image: BgOption1,
              },
              {
                image: BgOption2,
              },
              {
                image: BgOption3,
              },
            ],
          },
        },
        {
          label: "Primary Color",
          type: "color",
          key: "primary_color",
          style_key_group: "primary",
          value: "#000000",
        },
        {
          label: "Secondry Color",
          type: "color",
          key: "secondary_color",
          style_key_group: "secondary",
          value: "#feb022",
        },
        {
          label: "Primary Font",
          key: "primary_font",
          value: "Inter",
          type: "font",
        },
      ],
      swipe_indicator: {
        image: "",
      },
    };
    this.preview_images = [Slide1, Slide2, Slide3, Slide4];
    this.slides = [
      {
        elements: [
          {
            label: "Title",
            target_key: "title",
            type: "text",
            value: "Content Plan Strategy",
            max_words: 8,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "48px",
              },
              fontFamily: {
                key: "primary_font",
              },
              fontWeight: {
                value: "bold",
              },
            },
          },
        ],
        slide_type: "intro",
      },
      {
        elements: [
          {
            label: "Title",
            target_key: "title",
            value: "Paste your article",
            type: "text",
            max_words: 5,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "24px",
              },
              fontFamily: {
                key: "primary_font",
              },
              fontWeight: {
                value: "bold",
              },
            },
          },
          {
            label: "Description",
            target_key: "description",
            type: "multiline",
            value: `Read an interesting article that you want to share with your LinkedIn audience?

We've got you covered. Simply copy the link and paste the link to “Article to LinkedIn post” template inside Supergrow.

Note: The link should be public and accessible by anyone`,
            max_words: 25,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "14px",
              },
              fontFamily: {
                key: "primary_font",
              },
              fontWeight: {
                value: "normal",
              },
            },
          },
        ],
        slide_type: "middle",
      },
      {
        elements: [
          {
            label: "Title",
            target_key: "title",
            type: "text",
            value: "Select the format",
            max_words: 5,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "24px",
              },
              fontFamily: {
                key: "primary_font",
              },
              fontWeight: {
                value: "bold",
              },
            },
          },
          {
            label: "Description",
            target_key: "description",
            type: "multiline",
            value: `Once you paste the link, select your preferred format.

You can select from 10+ formats available at your fingertips to help you create visually appealing LinkedIn posts.

Your audience will love to simply love to read your posts.`,
            max_words: 25,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "14px",
              },
              fontFamily: {
                key: "primary_font",
              },
              fontWeight: {
                value: "normal",
              },
            },
          },
        ],
        slide_type: "middle",
      },
      {
        elements: [
          {
            label: "Title",
            target_key: "title",
            type: "text",
            value: "Try it out & let us know your feedback",
            max_words: 7,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "16px",
              },
              fontFamily: {
                key: "primary_font",
              },
              fontWeight: {
                value: "normal",
              },
            },
          },
          {
            label: "CTA Text",
            type: "text",
            target_key: "cta_text",
            value: "Comment below",
            max_words: 2,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "14px",
              },
              fontFamily: {
                key: "primary_font",
              },
              fontWeight: {
                value: "normal",
              },
            },
          },
        ],
        slide_type: "outro",
      },
    ];
  }

  setCommonSettings(settings) {
    this.common_settings = settings;
  }

  getPrimaryColor(common_settings) {
    return common_settings.elements[4].value;
  }

  getSecondaryColor(common_settings) {
    return common_settings.elements[5].value;
  }

  getPrimaryFont(common_settings) {
    return common_settings.elements[6]?.value;
  }

  duplicateSlide(slide, index) {
    let new_slide = JSON.parse(JSON.stringify(slide));
    this.slides.splice(index + 1, 0, new_slide);
    return new_slide;
  }

  renderOutroSlide(
    slide,
    index,
    currentSlide,
    carouselLength,
    commonSettings,
    updateSlideElementPosition,
    updateSlideElementSize,
    setCurrentSlideElement,
    previewMode
  ) {
    return (
      <>
        {index === carouselLength - 1 && (
          <>
            <div className="relative flex flex-col justify-between h-full px-10 pt-12 pb-8">
              <div>
                <div
                  className="text-2xl font-bold"
                  style={{
                    color: this.getPrimaryColor(commonSettings),
                  }}
                >
                  {slide.elements[0]?.style ? (
                    <MultilineView
                      element={slide.elements[0]}
                      getPropertyByStyleKey={(styleKey) =>
                        this.getPropertyByStyleKey(styleKey, commonSettings)
                      }
                      getValueByKey={(key) =>
                        this.getValueByKey(key, commonSettings)
                      }
                    />
                  ) : (
                    <TextView text={slide.elements[0]?.value} />
                  )}
                </div>
                <p
                  className="mt-4 text-base font-normal"
                  style={{
                    color: this.getPrimaryColor(commonSettings),
                  }}
                >
                  <TextView text={slide.elements[0]?.value} />
                </p>
                <div
                  className="inline-flex mt-4 text-sm font-semibold rounded-full items-center justify-center gap-2 px-4 py-2.5 "
                  style={{
                    backgroundColor: this.getSecondaryColor(commonSettings),
                  }}
                >
                  {slide.elements[1]?.style ? (
                    <MultilineView
                      element={slide.elements[1]}
                      getPropertyByStyleKey={(styleKey) =>
                        this.getPropertyByStyleKey(styleKey, commonSettings)
                      }
                      getValueByKey={(key) =>
                        this.getValueByKey(key, commonSettings)
                      }
                    />
                  ) : (
                    <TextView text={slide.elements[1]?.value} />
                  )}
                  <svg
                    className="w-5 h-5"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="currentColor"
                    viewBox="0 0 256 256"
                  >
                    <path d="M224.49,136.49l-72,72a12,12,0,0,1-17-17L187,140H40a12,12,0,0,1,0-24H187L135.51,64.48a12,12,0,0,1,17-17l72,72A12,12,0,0,1,224.49,136.49Z"></path>
                  </svg>
                </div>
              </div>

              <div>
                <svg
                  className="w-auto h-5"
                  viewBox="0 0 97 20"
                  fill="currentColor"
                  style={{
                    color: this.getSecondaryColor(commonSettings),
                    opacity: 0.3,
                  }}
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M20 10.2712C19.9397 12.8953 18.89 15.3644 16.7644 17.3554C15.7925 18.266 14.6695 18.939 13.4193 19.3927C12.0507 19.8902 10.5899 20.0823 9.1393 19.9556C7.68869 19.8289 6.2833 19.3865 5.02156 18.6593C4.92447 18.6034 4.846 18.621 4.75437 18.6546C3.57485 19.0846 2.39532 19.5164 1.21407 19.9405C0.863685 20.0662 0.540869 19.9902 0.276656 19.7283C0.00871841 19.4627 -0.0672676 19.1373 0.060369 18.7813C0.489467 17.5833 0.923034 16.3869 1.36107 15.1922C1.37514 15.1585 1.38069 15.1218 1.37723 15.0855C1.37376 15.0491 1.36139 15.0142 1.34121 14.9838C0.912669 14.2468 0.582648 13.4568 0.359595 12.6339C0.0714628 11.5907 -0.0428892 10.5072 0.0211344 9.42675C0.151585 7.27454 0.89398 5.36001 2.24832 3.68316C3.33422 2.34155 4.68831 1.35199 6.29222 0.712238C7.66774 0.16054 9.14935 -0.0757251 10.6281 0.0208109C14.4555 0.256338 17.8163 2.67571 19.2632 6.24142C19.7514 7.44365 19.9898 8.69656 20 10.2712Z" />
                  <path d="M55.2253 0.454346C52.1855 0.454346 50.5003 2.62872 50.5003 2.62872C50.5003 2.62872 48.815 0.454346 45.7753 0.454346C42.5854 0.454346 40.0002 3.01574 40.0002 6.17639C40.0002 10.5158 45.1579 14.721 46.5953 16.0495C48.2512 17.5789 50.5003 19.5452 50.5003 19.5452C50.5003 19.5452 52.7494 17.5789 54.4052 16.0495C55.8427 14.721 61.0003 10.5158 61.0003 6.17639C61.0003 3.01574 58.4152 0.454346 55.2253 0.454346Z" />
                  <path d="M96.2734 18.415C96.2734 18.884 95.7403 19.1541 95.3622 18.8766L88.9757 14.1909C88.7742 14.043 88.4999 14.043 88.2984 14.1909L81.9119 18.8766C81.5338 19.1541 81.0007 18.884 81.0007 18.415V1.02686C81.0007 0.710667 81.2571 0.454346 81.5732 0.454346H95.7009C96.0171 0.454346 96.2734 0.710668 96.2734 1.02686V18.415Z" />
                </svg>
              </div>
            </div>

            <div className="absolute -right-12 -bottom-6">
              <img
                className="w-64 h-64 rounded-full"
                src={commonSettings.elements[1].value.image}
                alt=""
              />
            </div>
          </>
        )}
      </>
    );
  }

  renderMiddleSlide(
    slide,
    index,
    currentSlide,
    carouselLength,
    common_settings,
    updateSlideElementPosition,
    updateSlideElementSize,
    setCurrentSlideElement,
    previewMode
  ) {
    return (
      <>
        {index !== carouselLength - 1 && index !== 0 && (
          <>
            <div
              className={
                (index % 2 === 1 ? " -left-40 " : " -right-40 ") +
                "absolute -top-40"
              }
            >
              <img
                className="opacity-25 w-96 h-96 mix-blend-multiply"
                src={FlowerPattern}
                alt=""
              />
            </div>

            <div className="relative flex flex-col justify-between h-full px-10 pt-12 pb-8">
              <div>
                <div
                  className="text-2xl font-bold"
                  style={{
                    color: this.getPrimaryColor(common_settings),
                  }}
                >
                  {slide.elements[0]?.style ? (
                    <MultilineView
                      element={slide.elements[0]}
                      getPropertyByStyleKey={(styleKey) =>
                        this.getPropertyByStyleKey(styleKey, common_settings)
                      }
                      getValueByKey={(key) =>
                        this.getValueByKey(key, common_settings)
                      }
                    />
                  ) : (
                    <TextView text={slide.elements[0]?.value} />
                  )}
                </div>
                <div
                  className="mt-4 text-sm font-normal leading-relaxed"
                  style={{
                    color: this.getPrimaryColor(common_settings),
                  }}
                >
                  {slide.elements[1]?.style ? (
                    <MultilineView
                      element={slide.elements[1]}
                      getPropertyByStyleKey={(styleKey) =>
                        this.getPropertyByStyleKey(styleKey, common_settings)
                      }
                      getValueByKey={(key) =>
                        this.getValueByKey(key, common_settings)
                      }
                    />
                  ) : (
                    <TextView text={slide.elements[1]?.value} />
                  )}
                </div>
              </div>
              <div className="flex items-center justify-between gap-4">
                <div
                  className={
                    "inline-flex items-center justify-center gap-2 rounded-full px-4 py-2.5 text-sm font-bold"
                  }
                  style={{
                    color: this.getPrimaryColor(common_settings),
                    border:
                      "2px solid " + this.getSecondaryColor(common_settings),
                  }}
                >
                  Swipe
                  <svg
                    className="w-5 h-5"
                    viewBox="0 0 20 20"
                    fill="none"
                    stroke="currentColor"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12.5 13.81V15.8267C12.4996 16.2705 12.323 16.696 12.0091 17.0097C11.6952 17.3234 11.2696 17.4998 10.8258 17.5H4.175C3.73091 17.5 3.30499 17.3236 2.99089 17.0097C2.67679 16.6958 2.50022 16.2699 2.5 15.8258V9.175C2.5 8.73091 2.67636 8.30499 2.9903 7.99089C3.30424 7.67679 3.73007 7.50022 4.17417 7.5H6.63583"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M7.63914 3.75913C7.75613 3.32431 8.04084 2.95367 8.4308 2.72854C8.82075 2.50341 9.2841 2.44218 9.71914 2.55829L16.2408 4.30579C16.6756 4.42278 17.0463 4.70749 17.2714 5.09744C17.4965 5.4874 17.5578 5.95074 17.4416 6.38579L15.6941 12.9075C15.5772 13.3423 15.2924 13.7129 14.9025 13.938C14.5125 14.1632 14.0492 14.2244 13.6141 14.1083L7.09165 12.3608C6.65683 12.2438 6.28619 11.9591 6.06106 11.5691C5.83593 11.1792 5.7747 10.7158 5.89081 10.2808L7.63914 3.75913Z"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
                <p
                  className="text-sm font-semibold tracking-widest"
                  style={{
                    color: this.getPrimaryColor(common_settings),
                    opacity: 0.5,
                  }}
                >
                  {index + 1} /{carouselLength}
                </p>
              </div>
            </div>
          </>
        )}
      </>
    );
  }

  renderIntroSlide(
    slide,
    index,
    currentSlide,
    carouselLength,
    commonSettings,
    updateSlideElementPosition,
    updateSlideElementSize,
    setCurrentSlideElement,
    previewMode
  ) {
    return (
      <>
        {index === 0 && (
          <>
            <div className="absolute -bottom-12 -right-20">
              <img
                className="opacity-25 w-96 h-96 mix-blend-multiply"
                src={FlowerPattern}
                alt=""
              />
            </div>

            <div className="relative flex flex-col justify-between h-full px-10 pt-12 pb-8">
              <div className="">
                <div
                  className="text-5xl font-bold"
                  style={{ color: this.getPrimaryColor(commonSettings) }}
                >
                  {slide.elements[0]?.style ? (
                    <MultilineView
                      element={slide.elements[0]}
                      getPropertyByStyleKey={(styleKey) =>
                        this.getPropertyByStyleKey(styleKey, commonSettings)
                      }
                      getValueByKey={(key) =>
                        this.getValueByKey(key, commonSettings)
                      }
                    />
                  ) : (
                    <TextView text={slide.elements[0]?.value} />
                  )}
                </div>
              </div>

              <div className="flex items-center gap-3">
                <img
                  className="object-cover rounded-full w-14 h-14"
                  src={commonSettings.elements[1].value.image}
                  alt=""
                />
                <div>
                  <p
                    className="text-lg font-bold whitespace-nowrap"
                    style={{ color: this.getPrimaryColor(commonSettings) }}
                  >
                    {<TextView text={commonSettings.elements[0]?.value} />}
                  </p>
                  <p
                    className="text-base font-normal"
                    style={{ color: this.getPrimaryColor(commonSettings) }}
                  >
                    {<TextView text={commonSettings.elements[2]?.value} />}
                  </p>
                </div>
              </div>
            </div>
          </>
        )}
      </>
    );
  }

  renderSlide(
    slide,
    index,
    currentSlide,
    carouselLength,
    common_settings,
    updateSlideElementPosition,
    updateSlideElementSize,
    setCurrentSlideElement,
    previewMode
  ) {
    return (
      <div
        key={index}
        className={
          "carousel-slide-container ring-1 ring-gray-200 bg-white relative shrink-0 aspect-[4/5] flex flex-col w-[400px] h-[500px] overflow-hidden " +
          (index !== currentSlide ? "hidden" : "") +
          " index-" +
          index
        }
        style={{
          fontFamily: this.getPrimaryFont(common_settings),
        }}
      >
        <div className="absolute inset-0">
          {common_settings.elements[3].value.type === "image" &&
            common_settings.elements[3].value.image && (
              <img
                className="object-cover w-full h-full"
                src={common_settings.elements[3].value.image}
                alt=""
              />
            )}
          {common_settings.elements[3].value.type === "color" && (
            <div
              className="w-full h-full"
              style={{
                backgroundColor: common_settings.elements[3].value.color,
              }}
            ></div>
          )}
        </div>
        {index === 0 &&
          this.renderIntroSlide(
            slide,
            index,
            currentSlide,
            carouselLength,
            common_settings,
            updateSlideElementPosition,
            updateSlideElementSize,
            setCurrentSlideElement,
            previewMode
          )}
        {index === carouselLength - 1 &&
          this.renderOutroSlide(
            slide,
            index,
            currentSlide,
            carouselLength,
            common_settings,
            updateSlideElementPosition,
            updateSlideElementSize,
            setCurrentSlideElement,
            previewMode
          )}
        {index !== carouselLength - 1 &&
          index !== 0 &&
          this.renderMiddleSlide(
            slide,
            index,
            currentSlide,
            carouselLength,
            common_settings,
            updateSlideElementPosition,
            updateSlideElementSize,
            setCurrentSlideElement,
            previewMode
          )}
      </div>
    );
  }
}

export default Basic4;
